import React from 'react';
import { BLUE_ARROW } from '../../../constants/urls';
import { BlueButton, BlueArrow } from './styles';

interface Props {
  buttonText: string;
  clicked: () => void;
}

const ViewButton: React.FC<Props> = ({ buttonText, clicked }) => (
  <BlueButton onClick={clicked}>
    <span>View {buttonText} </span>
    <BlueArrow src={BLUE_ARROW} alt="" />
  </BlueButton>
);

export default ViewButton;
